import React from "react";
import { Badge, Box, Card, Grid, Icon, Link, Modal, Progress, Text } from "~/components-shared";
import styled from "styled-components";
import { RoutesEnum } from "~/types/enums";
import StyledIcon from "~/components/StyledIcon";
const StyledText = styled(Text)`
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const TopicContributionsCard = _ref => {
  let {
    widget,
    ...rest
  } = _ref;
  const {
    previous,
    current
  } = widget.data;
  const [open, setOpen] = React.useState(false);
  const currentTotalCount = current.byTopic.reduce((p, c) => p + c.count, 0);
  const currentMaxCount = Math.max(...current.byTopic.map(t => t.count));
  const byTopic = [...current.byTopic.map(t => ({
    ...t,
    current: true
  })), ...previous.byTopic.filter(t => !current.byTopic.find(ct => ct.id === t.id)).map(t => ({
    ...t,
    current: false
  }))];
  const cardItem = (topic, index) => {
    const currentTopicCount = topic.count;
    const previousTopicIndex = previous.byTopic.findIndex(_ref2 => {
      let {
        id
      } = _ref2;
      return id === topic.id;
    });
    const previousTopicCount = previous.byTopic[previousTopicIndex]?.count || 0;
    const topicDeltaPercentage = previousTopicCount === 0 ? 0 : topic.current ? (currentTopicCount - previousTopicCount) / previousTopicCount * 100 : -100;
    const indexDiff = previousTopicIndex - index;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(StyledText, {
      fontSize: 4
    }, index + 1, ".", " ", /*#__PURE__*/React.createElement(Link, {
      href: RoutesEnum.TOPIC.replace(":topicId", topic.id),
      color: "primary"
    }, topic.name)), /*#__PURE__*/React.createElement(Text, {
      fontSize: 3,
      color: "textSecondary",
      weight: "semiBold"
    }, previousTopicIndex !== -1 && indexDiff !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
      src: "arrow",
      rotate: indexDiff >= 0 ? -90 : 90,
      s: {
        mt: -0.5
      },
      color: "inherit"
    }), previousTopicIndex !== -1 ? ` ${Math.abs(indexDiff)}` : "") : ""), /*#__PURE__*/React.createElement(Progress, {
      values: [topic.current ? (currentTopicCount / currentMaxCount || 1) * 100 : 0],
      labels: [`${currentTopicCount}`],
      height: 2
    }), /*#__PURE__*/React.createElement(Grid.Cell, {
      align: "start"
    }, /*#__PURE__*/React.createElement(Badge, {
      s: {
        py: 0,
        pl: topicDeltaPercentage === 0 ? 2 : 1
      },
      color: topicDeltaPercentage === 0 ? "translucentPrimary" : topicDeltaPercentage > 0 ? "translucentSuccess" : "translucentDanger"
    }, topicDeltaPercentage !== 0 && /*#__PURE__*/React.createElement(Icon, {
      src: "chevron",
      rotate: topicDeltaPercentage >= 0 ? 0 : 180,
      s: {
        mt: -0.5
      }
    }), topicDeltaPercentage === 0 ? "-" : `${Math.abs(topicDeltaPercentage).toFixed(0)}%`)));
  };
  return /*#__PURE__*/React.createElement(Card, rest, /*#__PURE__*/React.createElement(Box, {
    align: "end",
    s: {
      mb: 5
    },
    gap: 3
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: 15,
    lineHeight: 15
  }, currentTotalCount), /*#__PURE__*/React.createElement(Text, {
    element: "h5",
    fontSize: 5,
    lineHeight: 6,
    weight: "semiBold",
    display: "inline"
  }, "TOPIC", /*#__PURE__*/React.createElement("br", null), "CONTRIBUTIONS")), currentTotalCount !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "minmax(100px, 30%) minmax(1px, 40px) minmax(40px, 100%) auto",
    align: "center",
    gap: 3
  }, byTopic.slice(0, 6).map((topic, index) => cardItem(topic, index))), byTopic.length > 6 && /*#__PURE__*/React.createElement(Box, {
    justify: "end",
    s: {
      mt: 5
    }
  }, /*#__PURE__*/React.createElement(Link, {
    onClick: () => setOpen(true),
    color: "primary",
    fontSize: 4
  }, "See all", /*#__PURE__*/React.createElement(Icon, {
    src: "arrow",
    s: {
      ml: 1,
      mt: -0.5
    }
  }))), /*#__PURE__*/React.createElement(Modal, {
    open: open
  }, /*#__PURE__*/React.createElement(Modal.Body, {
    title: "Topic Contributions Items",
    onClose: () => setOpen(false),
    maxWidth: "600px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "auto 40px minmax(100px, 30%) auto",
    align: "center",
    gap: 4,
    s: {
      mt: 3
    }
  }, byTopic.map((item, index) => cardItem(item, index))))))) : /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "center",
    align: "center",
    fullHeight: true
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    src: "timelapse",
    color: "translucentWarning"
  }), /*#__PURE__*/React.createElement(Text, {
    element: "h3",
    weight: "semiBold",
    display: "block",
    s: {
      mt: 6
    },
    align: "center",
    style: {
      maxWidth: "300px"
    }
  }, "No Footprints mapped to any Topic")));
};
export default TopicContributionsCard;